var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloudUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5a6.003 6.003 0 00-5.674 4.045A5.001 5.001 0 007 19h11a4 4 0 000-8 6 6 0 00-6-6zm-5 5.2a3.8 3.8 0 100 7.6h11a2.8 2.8 0 100-5.6h-1.195c.011-.364.01-.763-.005-1.2a4.8 4.8 0 00-9.534-.8H7zm6 2.467h1.398a.5.5 0 00.376-.83l-2.398-2.74a.5.5 0 00-.752 0l-2.398 2.74a.5.5 0 00.376.83H11v2.83a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-2.83z"
  })));
}

export default SvgCloudUpload;